export class SzukajWEwidencjiModel {
    wartosc: string;
    kolumna: string;
    projektId: string;
}